import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '../../../../../node_modules/@material-ui/core';
import { CreativeFormat } from '../../../../graphql/generated/graphql_offer';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import _CreativeFormatDisplay from './CreativeFormatDisplay';

export interface Props {
  creativeFormat: Pick<CreativeFormat, 'network' | 'placement' | 'creativeType' | 'attribute' | 'resizeBaseId'>;
  itemIndex: number;
  className?: string;
}

const CreativeFormatListItem = ({ creativeFormat, itemIndex, className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <ItemIndex variant="caption" color="textSecondary">
        <FormattedMessage id="offer_display.creation_list_item.item_index.label" values={{ index: itemIndex }} />
      </ItemIndex>
      <CreativeFormatDisplay creativeFormat={creativeFormat} />
    </Root>
  );
};

export const Root = styled('div')(
  gridLayoutContainer({
    columns: ['auto', '1fr'],
    rows: ['auto'],
    areas: [['itemIndex', 'creative_format']],
    alignItems: 'center',
  }),
  {
    padding: `${SPACING_UNIT / 2}px ${SPACING_UNIT}px`,
  },
);

const ItemIndex = styled(Typography)({
  ...gridLayoutItem('itemIndex'),
  marginRight: SPACING_REGULAR,
});

const CreativeFormatDisplay = styled(_CreativeFormatDisplay)(gridLayoutItem('creative_format'));

export default CreativeFormatListItem;
